import type { ReactElement } from 'react';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import type { LoadingDotsProps } from '../Button.types';
import { useTextStyles } from '../styles';
import { LoadingDots as LoadingDotAni } from '../../LoadingDots';

export const LOADING_DOTS_TEST_ID = 'button-focus-ring';

export const LoadingDots = (props: LoadingDotsProps): ReactElement => {
  const { palette, size, hasDisabledStyle, uiEventState } = props;

  const useStyleState = useTextStyles(palette, size);
  // @ts-expect-error Property 'color' does not exist on type 'ViewStyle | TextStyle'.ts(2339)
  const { color } = StyleSheet.flatten(
    useStyleState(hasDisabledStyle, uiEventState),
  );

  return (
    <View testID={LOADING_DOTS_TEST_ID}>
      <LoadingDotAni color={color} />
    </View>
  );
};
